var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.213,
    height: 17.998,
    viewBox: "0 0 15.213 17.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Export",
    d: "M18230.5-6148a2.5,2.5,0,0,1-2.5-2.5V-6163.5a2.5,2.5,0,0,1,2.5-2.5h5.582l.242.078.064.019.041,0a1.036,1.036,0,0,1,.146.1l5.553,5.554a.773.773,0,0,1,.1.146v.06l.014.042a1.541,1.541,0,0,1,.041.183v2.82a.645.645,0,0,1-.646.646.644.644,0,0,1-.641-.646v-2.143h-3.072a2.5,2.5,0,0,1-2.5-2.5v-3.072h-4.922a1.212,1.212,0,0,0-1.209,1.213v12.994a1.212,1.212,0,0,0,1.209,1.213h4.643a.648.648,0,0,1,.645.65.642.642,0,0,1-.645.641Zm6.213-13.639a1.215,1.215,0,0,0,1.213,1.209h2.162l-3.375-3.37Zm2.615,11.6a.642.642,0,0,1-.189-.462.658.658,0,0,1,.184-.458l1.7-1.681h-5.879a.645.645,0,0,1-.646-.646.644.644,0,0,1,.646-.641h5.879l-1.7-1.685a.649.649,0,0,1,.006-.916.636.636,0,0,1,.457-.188.653.653,0,0,1,.457.188l2.785,2.779a.964.964,0,0,1,.137.22.646.646,0,0,1,0,.49l0,.009a.8.8,0,0,1-.129.206l-2.789,2.784a.657.657,0,0,1-.457.192A.64.64,0,0,1,18239.33-6150.042Z",
    transform: "translate(-18228.002 6165.998)",
    fill: "#242424",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export_icon.ecbf3d9b5a298f556713d7d3311b0d30.svg";
export { ForwardRef as ReactComponent };